import api from './api';

export interface WaitlistFormData {
  email: string;
  feature_name: string;
  user_name?: string;
  additional_info?: string;
}

export interface WaitlistFormResponse {
  success: boolean;
  message: string;
  reference_id?: string;
}

const waitlistService = {
  async joinWaitlist(formData: WaitlistFormData): Promise<WaitlistFormResponse> {
    const response = await api.post<WaitlistFormResponse>('/waitlist/join', {
      email: formData.email,
      feature_name: formData.feature_name,
      user_name: formData.user_name,
      additional_info: formData.additional_info
    });
    
    return response.data;
  }
};

export default waitlistService;